import * as React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        maxWidth: "100% !important",
      }}
      component="footer"
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Typography component="h4" sx={{ fontSize: ".75rem" }} variant="h4">
          {`Copyright © ${year} NWA Blog`}
        </Typography>
        <Button
          component={RouterLink}
          to="/copyright"
          variant="outlined"
          size="small"
          sx={{
            marginTop: ".25rem",
            marginBottom: ".25rem",
            textTransform: "none",
            color: "accent.main",
            borderColor: "accent.main",
            "&:hover": { borderColor: "accent.main" },
          }}
        >
          Copyright & DMCA
        </Button>
      </Box>
      <Box
        sx={{ bgcolor: "primary.main", height: ".25rem", width: "100%" }}
      ></Box>
      <Box
        sx={{ bgcolor: "secondary.main", height: ".5rem", width: "100%" }}
      ></Box>
    </Container>
  );
}
